<template>
  <div class="order-list tt-custom-tab article" style="padding:24px 32px 0;">  
    <!--<div>        
      <input class="content_search_input" v-model="searchWord" type="text" placeholder="搜索文章" @input="search(true)"/>
    </div>-->
    <div style="display:flex;">
      <!--<el-tabs v-model="form.type" @tab-click="handleTabClick">
        <el-tab-pane v-for="(tab,index) in tabs" :label="tab.name" :name="tab.value" :key="index">
        </el-tab-pane>
      </el-tabs>-->
      <div class="article-tabName" :class="{'selected':form.type==tab.value}" v-for="(tab,index) in tabs">
        {{ tab.name }}
      </div>
    </div>
    <!--
    <div class="search-bar">
      <div>
        <el-select style="width:100%;" v-model="form.mix_param" clearable filterable :filter-method="filterSearchMixer"
          class="input-width" @change="search" placeholder="商家或发件人">
          <el-option v-for="item in mixOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select :disabled="account_id==17852" style="width:100%;" v-model="form.receiver" clearable filterable :filter-method="filterSearchReceiver"
          class="input-width" @change="search" placeholder="收件人">
          <el-option v-for="item in receiverOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select style="width:100%;" v-model="form.merchant_id" clearable filterable :filter-method="filterSearch"
          class="input-width" @change="search" placeholder="商家">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select style="width:140px" v-model="form.mail_theme" class="mobile-select" placeholder="邮件主题" @change="search">
          <el-option v-for="(status, index) in mailTypes" :key="index" :label="status.label"
            :value="status.name"></el-option>
        </el-select>
      </div>
      <div style="margin-left:20px;">
        <el-select style="width:140px" v-model="form.status" class="mobile-select" placeholder="邮件状态" @change="search">
          <el-option v-for="(status, index) in mailStatusOptions" :key="index" :label="status.label"
            :value="status.name"></el-option>
        </el-select>
      </div>
    </div>-->
    <!--<div class="search-bar seprator">
      <div style="display:flex;align-items:center;">
        <span>
            {{totalCount}}个帖子&nbsp;&nbsp;
        </span>
      </div>
      <div>
        <div style="display:inline-block;">
          <el-date-picker format="yyyy-MM-dd HH:mm" v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']" @change="search">
          </el-date-picker>
        </div>
        <div style="display:inline-block;">
          
        </div>
      </div>
    </div>-->
    <div class="table" ref="scrollContainer" :style="{'height':tableHeight+'px'}" v-infinite-scroll="search" :infinite-scroll-distance="10">
      <div v-for="(list,w_index) in waterfallList" :key="w_index" style="width:210px;">
        <a v-for="(r,index) in list" :key="index" class="article_card" :href="`/explore/post?id=${r.post_id}`" @click.prevent="openArticleDetail(r.post_id)">
          <div style="position:relative;">
            <template v-if="r.media_list[0].type=='video'">
              <img v-if="r.cover_image_url" @error="handleImageError" :src="r.cover_image_url" class="article_card_img"/>
              <img v-else src="../../assets/images/joyLogoL.png" class="article_card_img"/>
              <div style="position:absolute;right:10px;top:10px;text-align: center;background:rgba(64,64,64,0.25);width:20px;height:20px;border-radius: 10px;">
                <i class="el-icon-caret-right" style="color:white;font-size: 17px;position: relative;top: 1px;transform: scaleX(1.2);"></i>
              </div>
            </template>
            <img v-else @error="handleImageError" referrerpolicy="no-referrer" :src="r.media_list[0].url" class="article_card_img"/>
            <div v-if="r.account_id==account_id" style="position: absolute;left:6px;bottom:6px;border-radius: 3px;background: rgba(0, 0, 0, 0.5);color: white;padding: 3px 5px;">
              <i class="el-icon-view" style="font-size: 16px;"></i> <label style="font-size:16px;">{{ r.views_count }}</label>
            </div>
          </div>
          <div style="padding:12px;">
            <div style="margin-bottom:8px;color:#333;font-size: 14px;line-height: 140%;">{{ r.title }}</div>
            <div style="display:flex;justify-content: space-between;align-items: center;">
              <div style="display: flex;align-items: center;">
                <template v-if="r.type!='0'">
                  <img class="flag" v-if="r.merchant_info && r.merchant_info.country" :src="`https://pic.joyorders.com/country/${r.merchant_info.country.toLowerCase()}.png`"/>
                  <img v-else src="../../assets/images/offlinePic.png" style="width:20px;height:20px;border-radius:10px;margin-right:6px;object-fit: contain;"/>
                </template>
                <template v-else>
                  <template v-if="r.account_profile">
                    <img :src="r.account_profile" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                  </template>
                  <template v-else>
                    <img src="../../assets/images/avatar@2x.png" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                  </template>
                </template>
                <template v-if="r.type!='0'">
                  <label style="font-size:12px;color:rgba(51, 51, 51, 0.8);">{{ r.merchant_info && (r.merchant_info.name || r.merchant_info.name_en)?(r.merchant_info.name || r.merchant_info.name_en):'未知商家' }}</label>
                </template>
                <template v-else>
                  <label style="font-size:12px;color:rgba(51, 51, 51, 0.8);">{{ (r.account_nickname || r.account_name) }}</label>
                </template>
              </div>
              <div style="display:flex;align-items: center;">
                <!--<img class="agree-icon" :class="{'animation':r.agreeclicked}" :src="r.agreeImageSrc" @click.stop.prevent="toggleLike(r)"/>-->
                <img class="view-icon" src="../../assets/images/view.png"/>
                <label style="color:rgba(51, 51, 51, 0.8);;font-size: 12px;">{{ r.views_count }}</label>
              </div>
            </div>
          </div>
          <!--<div>
            <p style="font-size:20px;">{{ r.title }}</p>
            <p style="font-size:12px;color:#aaa;margin:10px 0;">{{ generateDateDisplay(r.create_time) }}</p>
            <p v-html="r.content"></p>
          </div>-->
        </a>
      </div>
    </div>
    <div style="position: fixed;bottom:30px;right:60px;">
      <div class="waterfallbutton" style="margin-bottom:10px;">
        <i class="el-icon-top" style="font-size:20px;" @click.stop="toTop"></i>
      </div>
      <div class="waterfallbutton">
        <i class="el-icon-refresh" style="font-size:20px;" @click.stop="search(true)"></i>
      </div>
    </div>
    <!--<div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
        next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>-->

    <el-dialog v-if="articleDetailVisible" top="0" class="el-dialog-sm custom-width-dialog-90p no-padding" :show-close="false" :visible.sync="articleDetailVisible" width="auto">
      <ARTICLE :articleId="cur_articleId"></ARTICLE>
    </el-dialog>
  </div>
</template>

<script>
//import Mail from './MailBody.vue'
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'
import ARTICLE from '../../components/ArticleDetail'

let _ = require('lodash')

export default {
  name: 'OrderList',
  data() {
    return {
      articleDetailVisible:false,
      cur_articleId:'',
      tabs:[{name:'推荐',value:'1'}],
      API_HOST:API_HOST,
      account_id:this.$localStorage.get('account_id'),
      articleList: [],
      waterfallList:[],
      newArticle:{},
      rangeOptions: [{name:'0',label:'公开'},{name:'2',label:'私密'}],
      form:{
        limit:10,
        page:0,
        type:'1'
      },
      tableHeight:0,
      columnCount:5,
      totalCount:0,
      headers:{},
      editorOptions: {
        theme: 'snow', 
        modules: {
          toolbar: false
        },
        placeholder: '请输入内容...'
      }
    }
  },
  computed: {
      searchWord() {
        return this.$store.state.articleKeyword
      },
  },
  watch:{
    searchWord(){
      this.search(true)
    }
  },
  components:{
    ARTICLE
  },
  created () {
    this.headers.token = this.$localStorage.get('token')
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    if(viewportWidth>=1200)
      this.columnCount=5;
    else if(viewportWidth>=960)
      this.columnCount=4;
    else if(viewportWidth>=720)
      this.columnCount=3;
    else
      this.columnCount=2;
    this.tableHeight=window.innerHeight-238;
    if(this.$route.query.tag)
      this.$store.commit('setArticleKeyword', this.$route.query.tag); 
    this.search(true)
  },
  methods: {
    async toggleLike(c){
      let url = '';
      let id = c.post_id;
        if(c.liked==1){
          url = 'cancel_like';
          c.liked=0;
          c.agreeclicked=true;
          setTimeout(()=>{
            c.agreeImageSrc=require('@/assets/images/agree.png')
            this.$forceUpdate();
          },500)
          setTimeout(()=>{
            c.agreeclicked=false;
            this.$forceUpdate();
          },1000)
        }
        else{
          url = 'like';
          c.liked=1;
          c.agreeclicked=true;
          setTimeout(()=>{
            c.agreeImageSrc=require('@/assets/images/agree-full.png')
            this.$forceUpdate();
          },500)
          setTimeout(()=>{
            c.agreeclicked=false;
            this.$forceUpdate();
          },1000)
        }
      let res = await api.post(this, {
        path: 'cm.php',
        api: url,
        data: {
          target_type:'post',
          target_id:id
        }
      })
      res = res.body
      if (res.status == 'ok') {
        let t = +c.likes_count;
        if(c.liked==1){
          c.likes_count=t+1;
        }
        else{
          c.likes_count=t-1;
        }
      } 
    },
    toTop(){
      this.$refs.scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleImageError(e){
      e.target.src=require('@/assets/images/joyLogoL.png');
      e.target.onerror = null;
    },
    openArticleDetail(id){
      this.cur_articleId=id;
      this.articleDetailVisible=true;
    },
    handleTabClick(tab){
      console.log('tabs',tab);
    },
    search(needReload){
      const generateParams=(needReload)=>{
        let params={}
        params.limit=this.form.limit;
        if(needReload)
          this.form.page=1
        else
          this.form.page++;
        params.page=this.form.page;
        if(this.searchWord.trim()!='')
          params.keyword=this.searchWord
        /*for(let p in this.form){
          if(this.form[p])
            params[p]=this.form[p]
        }
        if(this.timeRange.length){
          params.start_time=this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
          params.end_time=this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
        }
        if(this.searchWord){
          switch(this.keyword_type){
            case '1':
              params.merchant_order_number=this.searchWord;
              break;
            case '2':
              params.tracking_number=this.searchWord;
              break;
            case '3':
              params.gift_card_number=this.searchWord;
              break;
          }
        }*/
        return params
      }
      let params=generateParams(needReload)
      this.getList(params,needReload);
      if(needReload)
        this.getListCount(params);
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    getList(params,needReload) {
      api.getArticleList(this, params).then((res) => {
        this.articleList = res.body.result;
        //let columnindex_arr = [];
        if(needReload){
          this.$refs.scrollContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          this.waterfallList=[]
          for(var i=0;i<this.columnCount;i++){
            //columnindex_arr.push(i);
            this.waterfallList.push([]);
          }
        }
        this.articleList.forEach((i,index)=>{
          i.agreeImageSrc=i.liked==1? require('@/assets/images/agree-full.png'):require('@/assets/images/agree.png');
          let yy = index%this.columnCount;
          this.waterfallList[yy].push(i);
        })
      })
    },
    getListCount(params){
      delete params.page
      delete params.limit
      api.getArticleCount(this,params).then((res)=>{
        this.totalCount=+res.body.result;
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .flag {
    width: 20px;
    height: 14px;
    margin-right:3px;
    object-fit: contain;
  }
  .article-tabName{
    color:#666;
    font-size: 16px;
    height:40px;
    line-height: 40px;
  }
  .article-tabName.selected{
    background:rgba(0,0,0,0.03);
    padding:0 16px;
    font-weight: bold;
    color:#333;
    border-radius: 3px;
  }
  .waterfallbutton{
    cursor: pointer;
    background: white;
    box-shadow:0 2px 8px 0 rgba(0,0,0,.05),4px 4px 2px 0 rgba(0,0,0,.3);
    border-radius: 20px;
    width:40px;
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .article_card{
    width:210px;
    margin-bottom:10px;
    padding-bottom:10px;
    cursor: pointer;
    display:inline-block;
    color:#333;
  }
  .article_card_img{
    width:100%;
    max-height: 283px;
    object-fit: cover;
    border-radius: 3px;
    border:1px solid rgba(0,0,0,.08);
  }
.empty-content {
  padding: 50px 0 50px;
}
.table{
  position: relative;
  margin-top:30px;
  display:flex;
  overflow: auto;
  justify-content: space-between;
}
.table::-webkit-scrollbar {
  display: none;
}
.order-list{
  margin-bottom: 0 !important;
}
</style>

<style lang="scss">
.order-list {
  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.yd-pagination{
  margin-top:30px;
}

@font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  src: 
       url('../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-icon-joyorderagree:before {
  content: "\e61d";
}
</style>



// WEBPACK FOOTER //
// src/pages/articles/List.vue